import React from 'react'

import { Element, Image, Text } from "components/shared/base"
import {
  PrismicHomepageDataBodyHeroPrimary
} from "types/__generated__/gatsby-graphql"
import { mapColumnSize } from "utils"

export type HeroProps = PrismicHomepageDataBodyHeroPrimary

const Hero: React.FC<HeroProps> = ({
  background_color = "",
  headline,
  headline_font_color,
  headline_width,
  hide_intro_top_border,
  image,
  image_should_be_background,
  intro,
  intro_font_color
}): React.ReactElement => {
  const bgImage =
    image_should_be_background && image?.url ? `url("${image.url}")` : null;
  const columnSize = mapColumnSize(headline_width);
  const headlineFontColor = headline_font_color || "coral";
  const introFontColor = intro_font_color || "white";

  return (
    <Element
      as="section"
      background={bgImage}
      bg={background_color}
      mb="45px"
      p={["100px 20px 40px", "155px 20px 115px"]}
    >
      <Element m="0 auto" maxWidth="contentWidth">
        {!image_should_be_background && image ? (
          <Image alt={image?.alt} image={image?.gatsbyImageData} mb="75px" />
        ) : null}
        <Element display="grid" gridTemplateColumns="repeat(12, 1fr)">
          {headline?.text && (
            <Text
              as="h1"
              color={headlineFontColor}
              fontSize={["text.headerMobile", "text.header"]}
              gridColumnEnd={columnSize.gridColumnEnd}
              gridColumnStart={columnSize.gridColumnStart}
              lineHeight="header"
              textAlign="center"
            >
              {headline?.text}
            </Text>
          )}
        </Element>
        {intro && (
          <Text
            borderTop={!hide_intro_top_border ? `1px solid ${introFontColor}` : "0"}
            color={introFontColor}
            fontSize={["text.primaryMobile", "text.primary"]}
            lineHeight="primary"
            mt={["100px", "155px"]}
            pt={["25px", "35px"]}
            textAlign="center"
          >
            {intro}
          </Text>
        )}
        </Element>
    </Element>
  )
}

export default Hero
